export default __webpack_public_path__ + "static/media/funchan.18a23985.svg";